import { Stack, styled, Typography } from '@mui/material';
import { memo } from 'react';
import { Link } from 'react-router';
import type ViewProductStore from '../../AppData/_stores/ViewProductStore';
import ProductCatalogPricing from './ProductCatalogPricing';
import ProductCatalogPrintTypeTag from './ProductCatalogPrintTypeTag';

interface ProductCatalogCardContentProps {
  isOnSale: boolean
  onProductInfoClick?: () => void
  product: ViewProductStore
  productInfoUrl?: string
  showPricing?: boolean
}

const ProductName = styled(Typography)(({ theme }) => ({
  color: 'var(--product-catalog-card-content-color)',
  transition: 'color 250ms',
  lineHeight: '1.3',

  [theme.breakpoints.down('sm')]: {
    fontSize: '1rem',
  },
}));

const ProductDescription = styled(Typography)({
  color: 'var(--product-catalog-card-description-color)',
  display: '-webkit-box',
  overflow: 'hidden',
  transition: 'color 250ms',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 2,
});

const ProductTitleLink = styled(Link)({
  display: 'block',
  textDecoration: 'none',
});

const ProductContent = styled(Stack)(({ theme }) => ({
  flexGrow: 1,
  padding: theme.spacing(2),

  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1),
  }
}));

function ProductCatalogCardContent(props: ProductCatalogCardContentProps) {
  return <ProductContent spacing={{ xs: 0.5, sm: 1 }}>
    <ProductCatalogPrintTypeTag product={props.product} />
    <Stack spacing={2} sx={{flexGrow: 1, justifyContent: 'space-between'}}>
      <Stack spacing={0.5}>
        {props.productInfoUrl !== undefined ? <ProductTitleLink
            to={props.productInfoUrl}
            reloadDocument={!props.product.get('is_react_page')}
            onClick={props.onProductInfoClick}
          >
            <ProductName variant="h4">{props.product.get('name')}</ProductName>
          </ProductTitleLink> : <ProductName variant="h4">{props.product.get('name')}</ProductName>}

        <ProductDescription variant="body2" sx={{ display: { xs: 'none', sm: 'block' } }} >
          {props.product.get('description')}
        </ProductDescription>
      </Stack>

      {props.showPricing !== false ? <ProductCatalogPricing product={props.product} isOnSale={props.isOnSale} /> : null}
    </Stack>
  </ProductContent>
}

export default memo(ProductCatalogCardContent);
